// Traffic-light thresholds per 100 g / 100 ml (FSA/EU front-of-pack scheme, also referenced by SGE/BLV guidance).
const SOLID = { sugar: [5, 22.5], saturated_fat: [1.5, 5], salt: [0.3, 1.5] };
const DRINK = { sugar: [2.5, 11.25], saturated_fat: [0.75, 2.5], salt: [0.3, 0.75] };

export const LIGHT_STYLES = {
  green: { bg: "bg-emerald-50 dark:bg-emerald-900/25", ring: "ring-emerald-200/70 dark:ring-emerald-700/40", dot: "bg-emerald-500", text: "text-emerald-700 dark:text-emerald-300" },
  amber: { bg: "bg-amber-50 dark:bg-amber-900/25", ring: "ring-amber-200/70 dark:ring-amber-700/40", dot: "bg-amber-400", text: "text-amber-700 dark:text-amber-300" },
  red: { bg: "bg-rose-50 dark:bg-rose-900/25", ring: "ring-rose-200/70 dark:ring-rose-700/40", dot: "bg-rose-500", text: "text-rose-700 dark:text-rose-300" },
};

/** Returns "green" | "amber" | "red" | null for a per-100g value of sugar / saturated_fat / salt. */
export function trafficLight(kind, per100, isDrink = false) {
  const th = (isDrink ? DRINK : SOLID)[kind];
  if (!th || per100 == null || Number.isNaN(+per100)) return null;
  const v = +per100;
  return v <= th[0] ? "green" : v > th[1] ? "red" : "amber";
}
